import { render, staticRenderFns } from "./Rekrutmen.vue?vue&type=template&id=5cf66c66&scoped=true"
import script from "./Rekrutmen.vue?vue&type=script&lang=js"
export * from "./Rekrutmen.vue?vue&type=script&lang=js"
import style0 from "./Rekrutmen.vue?vue&type=style&index=0&id=5cf66c66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf66c66",
  null
  
)

export default component.exports